module.exports = __webpack_public_path__ + "img/greendragon.c0f36705.png";